import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import personalGoal from "../../assets/images/personal-goal.svg";
import { Navigate } from "react-router";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Icon from '@mui/material/Icon';
import * as Util from "../../services/global.service";

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { icon, btn, color, open, close, data, description, name } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  useEffect(() => {

  }, []);
  const handleCloseDialog = () => {
    close(false);
  };
  return (
    <Dialog onBackdropClick={() => {return false}} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }} color="#404349">
        {t('evaluation.goalDetail')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0" }}>
        <Box sx={{ padding: "30px 0" }}>
          <Box sx={{ background: data?.type?.options?.color, "border-radius": "5px", height: "40px", display: "flex", width: "max-content", padding: "0 11px", alignItems: "center" }}>
            <Icon sx={{ color: "#ffffff", "font-size": "20px", "margin-right": "10px" }}>{data?.type?.options?.icon}</Icon>
            <Typography fontSize={16} lineHeight="16px" color="#FFFFFF">
              {/* {btn} */} {data?.type?.description}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", "flex-flow": "row wrap" }}>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalName')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.name}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalDescription')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.description}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalGroup')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.goal_group}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalSubGroup')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.goal_subgroup}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('mygoal.label.measurement')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.measurement}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalMetric')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.metricDescription}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.targetValue')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.target_value}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.goalLinkingType')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {data?.alignment_type}
            </Typography>
          </Box>
          <Box className={classes.boxLeft} sx={{ display: "flex", "align-items": "center" }}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.linkedGoal')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            {Util.formatData(data?.linked?.goal?.serial, false) !== false ?
              <Box onClick={e => navigate(`/kpi/mygoal-detail/${data?.linked?.goal?.serial}`, { replace: false })} sx={{ display: "flex", background: "#FFFFFF", "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.15)", "border-radius": "4px", width: "342px", height: "50px", "align-items": "center", padding: "10px", cursor: "pointer" }}>
                <Box sx={{ display: "flex", width: "calc(100% - 30px)" }} pr="10px">
                  <Icon sx={{ color: data?.linked?.goal?.goal_category?.color, "font-size": "25px", "margin-right": "10px" }}>{data?.linked?.goal?.goal_category?.icon}</Icon>
                  <Typography fontSize={18} lineHeight="26.91px" color="#404349" sx={{ overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis", width: "100%" }}>
                    {data?.linked?.goal?.name}
                  </Typography>
                </Box>
                <Box sx={{ background: "#F5F5F5", "border-radius": "3px", padding: "5px", width: "30px", height: "30px" }}>
                  <img src={arrowLinkedGoal} alt="kpiArrow" style={{ height: "20px" }} />
                </Box>
              </Box>
              :
              <Box sx={{ display: "flex", background: "#FFFFFF", "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.15)", "border-radius": "4px", width: "342px", height: "50px", "align-items": "center", padding: "10px" }}  >
                <Typography fontSize={18} lineHeight="26.91px" color="#404349" sx={{ overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis", width: "100%" }}>
                  -
                </Typography>
              </Box>
            }
          </Box>
          {data?.more_detail?.length > 0 &&
            data?.more_detail?.map((item) => {
              return <>
                <Box className={classes.boxLeft}>
                  <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
                    {item?.label}
                  </Typography>
                </Box>
                <Box className={classes.boxRight}>
                  <Typography fontSize={18} lineHeight="26.91px" color="#404349">
                  {item.type === 'dropdown' 
                    ? i18n.language === "th-TH" ? item?.options?.data?.find((data) => data.id === item.value).label.th :  item?.options?.data?.find((data) => data.id === item.value).label.en
                    : Util.capitalizedString(item.value || '-') || '-'}
                  </Typography>
                </Box>
              </>
            })
          }
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
